<template>
<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plug"
     role="img"
     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    <path fill="currentColor"
          d="M312 24C312 10.75 301.2 0 288 0s-24 10.75-24 24V112h48V24zM120 24C120 10.75 109.2 0 96 0S72 10.75 72 24V112h48V24zM360 144H23.1C10.75 144 0 154.7 0 167.1S10.75 192 23.1 192H32v64c0 80.13 59.13 145.9 136 157.6v74.38C168 501.3 178.7 512 192 512s24-10.75 24-23.1v-74.38C292.9 401.9 352 336.1 352 256V192h8C373.3 192 384 181.3 384 168S373.3 144 360 144zM304 256c0 61.88-50.13 112-112 112S80 317.9 80 256V192h224V256z"></path>
</svg>
</template>
      